/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import { propTypesLink } from '../../../constants/Proptypes';

const propTypesSliceTableOfContent = {
  table_of_content_description: PropTypes.string,
};

const propTypesItemsTableOfContent = {
  content_part_name: PropTypes.string,
  content_part_url: PropTypes.shape(propTypesLink),
};

export const propTypesDataTableOfContent = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceTableOfContent),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsTableOfContent)),
};
